exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination{-webkit-box-pack:end!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.pagination .page-stats{-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:5px}.pagination a{background-color:#acacac!important;color:#fff;padding:5px;margin-top:-5px;margin-right:5px;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5ef246c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/datatable/Pagination.vue
// module id = xtLV
// module chunks = 0